import React from 'react';
import BonusRegistration from '../../components/bonus-registration';
import {useRouter} from '../../../../../@casino/useRouter';
import BonusNextDeposit from '../../components/bonus-next-deposit';
import BonusWeekly from '../../components/bonus-weekly';
import BonusFirstDeposit from '../../components/bonus-first-deposit';
import BonusPromocode from '../../components/bonus-promocode';
import BonusCashBack from '../../components/bonus-cashback';
import BonusEveryDay from '../../components/bonus-everyday';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    }
}))

const BonusSettings = () => {
    const router = useRouter();
    const {bonus, id} = router.query
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {
                (bonus === 'bonus-registration' || bonus === 'bonus-personal') &&
                <BonusRegistration id={id} />
            }
            {
                bonus === 'bonus-next-deposit' &&
                <BonusNextDeposit id={id} />
            }
            {
                bonus === 'bonus-weekly' &&
                <BonusWeekly id={id} />
            }
            {
                bonus === 'bonus-first-deposit' &&
                <BonusFirstDeposit id={id}/>
            }
            {
                bonus === 'bonus-promocode' && 
                <BonusPromocode id={id}/>
            }
            {
                bonus === 'bonus-cashback' &&
                <BonusCashBack id={id}/>
            }
            {
                bonus === 'bonus-everyday' &&
                <BonusEveryDay id={id} />
            }
        </div>
    )
}

export default BonusSettings;